import { render, staticRenderFns } from "./wty-selectBox.vue?vue&type=template&id=c6470f18&scoped=true&"
import script from "./wty-selectBox.vue?vue&type=script&lang=js&"
export * from "./wty-selectBox.vue?vue&type=script&lang=js&"
import style0 from "./wty-selectBox.vue?vue&type=style&index=0&id=c6470f18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6470f18",
  null
  
)

export default component.exports